<ion-header>
  <app-header
     [isBackgroundWhite]="true"
    [pageTitle]="pageTitle"
    [showBackArrow]="showBackArrow"
    [isTemplateFolder]="isTemplateFolder"
  >
  </app-header>
</ion-header>

<ion-content>
  <div class="content-max-width">
    <div class="template-section">
      <app-search
        [isTemplateFolder]="isTemplateFolder"
        [showTemplateFolder]="showTemplateFolder"
        (resultFolderEmitter)="handleResultFolder($event)"
      ></app-search>

      <div class="folder">
        {{ '_folders_' | translate }}
      </div>
      <div *ngIf="templateFolders.length === 0 && !isAssigned && !isStore && !isLoading ">
        <p class="no-post-available">{{'_no_folders_available_' | translate}}.</p>
      </div>
      <div *ngIf="!isLoading" class="folder-container">

        <div *ngIf="isAssigned" (click)="onNavigateToTemplates('assigned')" class="folder-content">
          <ion-icon name="folder" class="folder-icon"></ion-icon>
          <p class="content-title">{{ '_assigned_to_you_' | translate }}</p>
        </div>
        <div *ngIf="isStore" (click)="onNavigateToTemplates('saved')" class="folder-content">
          <ion-icon name="folder" class="folder-icon"></ion-icon>
          <p class="content-title">{{ '_saved_to_you_' | translate }}</p>
        </div>
        <div *ngFor="let templateFolder of templateFolders" class="folder-content">
          <div *ngIf="templateFolders.length !== 0">
            <div (click)="onNavigateToTemplates('',templateFolder.id)">
              <img
                (load)="onImageLoad($event)"
                [src]="templateFolder.image.url"
                class="result-img"
              />
              <p class="content-title">{{templateFolder.title}}</p>
              <p class="content-subtitle">{{templateFolder.description}}</p>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="isLoading">
        <app-template-folder-list-skeleton></app-template-folder-list-skeleton>
      </div>

    </div>
  </div>

  <ion-infinite-scroll (ionInfinite)="loadMore($event)" class="ion-margin-top">
    <ion-infinite-scroll-content>
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>

</ion-content>
